// Remove unused parameters from URL in GET request by disabling the form fields
export default function clearSearch() {
  $('.search-get-form').off('submit.clearSearch').on('submit.clearSearch', function () {
    $(this).find('input').each(function () {
      if ($(this).val() === '') {
        $(this).attr('disabled', true);
      }
    });

    $(this).find('select').each(function () {
      if ($(this).val() === '' || $(this).val() === null || $(this).val() === undefined) {
        $(this).attr('disabled', true);
      }
    });

    $(this).find('button').each(function () {
      $(this).attr('disabled', true);
    });
  });
}
